'use client'

import { Provider } from 'react-redux'
import { store } from './store'
import { useRef, useEffect } from 'react'
import type { RootState } from './store'
import { setConfig } from './slices/configSlice'

export default function StoreProvider({ 
  children,
  preloadedState
}: { 
  children: React.ReactNode
  preloadedState?: Partial<RootState>
}) {
  const storeRef = useRef(store)

  useEffect(() => {
    if (preloadedState?.config) {
      storeRef.current.dispatch(setConfig(preloadedState.config))
    }
  }, [preloadedState])

  return (
    <Provider store={storeRef.current}>
      {children}
    </Provider>
  )
}
